import { atom } from "recoil";

export const selectedCompanyState = atom({
  key: "selectedCompanyState",
  default: "",
});
